import { Button, Divider, FormControl, FormLabel, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Switch, useDisclosure, useToast } from "@chakra-ui/react";
import React from "react";
import axios from "axios";
import { useState } from "react";
import { ChatState } from "../../../Context/ChatProvider";


function Level_crud({ setFetchAgain }) {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const toast = useToast();
   
    const [levelName, setLevelName] = useState("");
    const [price, setPrice] = useState('');
    const [picLoading, setPicLoading] = useState(false);

    const { user } = ChatState();

    const openModal = () => {
      
        setLevelName("");
        setPrice("");
        onOpen()
    }
    const newLevel = async () => {

        if ( !levelName || !price) {
            toast({
                title: "Veuillez remplir tous les champs",
                status: "warning",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });
            setPicLoading(false);
            return;
        }

        try {
            const config = {
                headers: {
                    "Content-type": "application/json",
                    Authorization: `Bearer ${user.token}`,
                },
            };
            await axios.post(
                "/api/level",
                {
                    levelName,
                    price
                },
                config
            );
            toast({
                title: "Erfolgreich hinzugefügt",
                status: "success",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });


            setFetchAgain(true);
        } catch (error) {
            toast({
                title: "Une erreur s'est produite !",
                description: error.response.data.message,
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });

        }
        onClose()
    };








    return <>
        <Button bg='gray.50' className="p-2"  onClick={() => { openModal() }}><i className="fa-solid fa-plus text-blue-400 mx-2"></i>Nouvel Niveau</Button>
        <Modal

            isOpen={isOpen}
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent m='auto'>
                <ModalHeader className="bg-gray-50 shadow-md text-black text-xl"><i className="fa-solid fa-layer-group text-2xl mr-1"></i> Niveau</ModalHeader>
                
                <ModalBody pb={6}>


                    <div className="mr-4">

                        <FormControl mt={4}>
                            <Input placeholder='Niveau' id='levelName' value={levelName}
                                onChange={(e) => setLevelName(e.target.value)} />
                        </FormControl>

                        <FormControl mt={4}>
                            <Input placeholder='Prix' id='price' value={price}
                                onChange={(e) => setPrice(e.target.value)} />
                        </FormControl>

                    </div>


                </ModalBody>

                <ModalFooter>
                    <Button colorScheme='blue' mr={3}
                        onClick={newLevel}
                        isLoading={picLoading}>
                        Enregistrer
                    </Button>
                    <Button onClick={onClose}>Annuler</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    </>
}

export default Level_crud